var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatteryChargingIconOnly({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 38,
    viewBox: "0 0 25 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.02476 1.7933C7.02476 0.513756 7.41023 0.253906 8.56416 0.253906H17.0296C18.1848 0.253906 18.569 0.514987 18.569 1.7933V2.94723H22.0332C24.3066 2.94723 24.7266 3.36594 24.7266 5.64055V34.5048C24.7266 36.7782 24.3078 37.1981 22.0332 37.1981H3.56051C1.28713 37.1981 0.867188 36.7794 0.867188 34.5048V5.64055C0.867188 3.36718 1.2859 2.94723 3.56051 2.94723H7.02476V1.7933ZM13.4869 17.7631L20.4588 9.66406H12.7122L6.51493 20.4629H12.2474L7.28961 31.2617L19.6841 17.7631H13.4869Z",
    fill: "#CF202F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryChargingIconOnly);
export default __webpack_public_path__ + "static/media/BatteryCharging_IconOnly.b392b6b987d7dd8ae880dbdb3ba24142.svg";
export { ForwardRef as ReactComponent };